import Recoil from 'recoil';
import localStorageEffect from './localStorageEffect';
const last_doctor_id = Recoil.atom({
  key: 'app.last_doctor_id',
  default: null,
  effects: [
    localStorageEffect('_I', null, { initial: false, encryption: true }),
  ]
});
export default last_doctor_id;